import { render, staticRenderFns } from "./NaturalSolutions.vue?vue&type=template&id=66f67f6d&scoped=true&"
import script from "./NaturalSolutions.vue?vue&type=script&lang=js&"
export * from "./NaturalSolutions.vue?vue&type=script&lang=js&"
import style0 from "./NaturalSolutions.vue?vue&type=style&index=0&id=66f67f6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f67f6d",
  null
  
)

export default component.exports